"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Module {
    constructor(obj) {
        this.name = '';
        this.slug = '';
        this.url = '';
        this.tags = {};
        this.description = '';
        this.name = obj.name || '';
        this.slug = obj.slug || '';
        this.url = obj.url || '';
        this.tags = obj.tags || {};
        this.description = obj.description || '';
    }
    switchToThisModule() {
        this.setThisAsCurrentModule();
        if (this.url.length > 1) {
            window.location.href = this.url;
        }
        else {
            switch (this.slug) {
                case 'results':
                    window.location.href = '/dashboard';
                    break;
                case 'proposals':
                    window.location.href = 'http://planner.biomemakers.com/';
                    break;
                case 'tracking':
                    window.location.href = '/tracking/';
                    break;
                default:
                    window.location.href = '/dashboard/';
                    break;
            }
        }
    }
    setThisAsCurrentModule() {
        const exceptions = ['proposals'];
        if (!exceptions.includes(this.slug)) {
            localStorage.setItem('currentModule', this.slug);
        }
    }
}
exports.default = Module;
